import type { Selectors } from '@makemydeal/dr-activities-role-assumption';
import { init } from '@makemydeal/dr-activities-role-assumption';
import { APP_NAME } from './constants';
import { additionalSelectors } from './additionalSelectors';
import { hostActions } from './hostActions';

let roleAssumptionSelectors: Selectors;

export const configureRoleAssumption = () => {
    const { middlewareMgr, selectors } = init(APP_NAME, additionalSelectors, hostActions);
    roleAssumptionSelectors = selectors;
    return middlewareMgr;
};

export const getRoleAssumptionSelectors = (): Selectors => roleAssumptionSelectors;
